var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-4 card-indicador",attrs:{"headers":_vm.headers,"single-expand":true,"items":_vm.desserts,"items-per-page":5,"sort-by":_vm.sortBy,"sort-desc":true,"footer-props":{
      'items-per-page-text': 'Resultados por página',
      'items-per-page-all-text': 'Todos',
      'page-text': '{0}-{1} de {2}'
    }},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sort-by":function($event){_vm.sortBy=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }